// Free plan (limited access mode - not displayed as a selectable plan)
export const freePlan = {
  name: "Limited Access",
  price: "$0",
  period: "/month",
  originalPrice: null,
  annualPrice: "$0",
  annualSavings: null,
  description: "Basic access with your existing data preserved",
  tagline: "No Pressure. No Lost Progress.",
  features: [
    "Your existing data preserved",
    "Basic dashboard access",
    "Baseline room scan",
    "MyDailyCheckIn"
  ],
  cta: "Included automatically",
  popular: false,
  trial: false,
  category: "personal"
};

// Paid personal plans only (displayed in dual-path cards)
export const personalPlans = [
  {
    name: "ThriveMax",
    categoryLabel: "For Older Adults",
    price: "$29",
    period: "/month",
    originalPrice: null,
    annualPrice: "$299",
    annualSavings: null,
    description: "ThriveMax gives you visibility, accountability, and momentum — all in one place.",
    tagline: "Your daily structure for living safely at home.",
    emotionalHook: "Designed to support independence, not take it over.",
    features: [
      "Identify hazards early with unlimited ThriveVision scans",
      "Quantify your wellness with ThriveScore",
      "Master your routine with MyDailyCheckIn",
      "Ensure medication accuracy with shared logs",
      "Invite one family member for shared visibility"
    ],
    cta: "Request ThriveMax Access",
    popular: false,
    trial: false,
    category: "personal",
    billingNote: "Includes a 7-day trial. Continue only if it feels valuable.",
    trustBadges: [
      { icon: "clock", text: "Free for 7 days" },
      { icon: "shield", text: "Safe & secure, 365 days a year" }
    ],
    testimonial: {
      quote: "It feels like a safety net, not a camera. I feel safe without giving up my privacy.",
      author: "Margaret, 72"
    }
  },
  {
    name: "ThriveFamily",
    categoryLabel: "For Family Members",
    price: "$59",
    period: "/month",
    originalPrice: null,
    annualPrice: "$599",
    annualSavings: null,
    description: "ThriveFamily brings everyone into one aligned, shared view of safety and care.",
    tagline: "Independence at home. Strength together.",
    emotionalHook: "Built to reduce worry, not add more work.",
    features: [
      "Everything in ThriveMax",
      "Eliminate sibling guesswork with shared dashboard",
      "Coordinate without chaos via task collaboration",
      "Proactive care alignment tools",
      "Real-time safety and wellness visibility"
    ],
    cta: "Request ThriveFamily Access",
    popular: true,
    trial: false,
    category: "personal",
    trustBadges: [
      { icon: "clock", text: "Free to explore" },
      { icon: "shield", text: "Billing starts when an older adult joins" }
    ],
    badgeTooltip: {
      headline: "No rush. Get ready first.",
      body: "Take your time to invite family and organize tasks for free. Your subscription doesn't start until the senior connects and is active."
    },
    billingNote: "Explore free. Billing begins only after the older adult joins and activates the household.",
    testimonial: {
      quote: "I stopped calling ten times a day just to check in. Now I know she's okay, and our calls are actually about us.",
      author: "David, son"
    }
  },
];

// Add-on plans (not displayed as cards, explained in separate sections)
export const addOnPlans = {
  familyPlus: {
    name: "ThriveFamily+",
    price: "+$10",
    period: "/month",
    description: "Expanded family support for deeper care coordination"
  },
  thriveCare: {
    name: "ThriveCare Add-On",
    price: "+$15",
    period: "/caregiver/month",
    description: "Professional caregiver access when invited by a family"
  }
};
